export const JOB_STATE = {
    RUNNING: 0,
    SUCCESS: 1,
    FAILED: 2
}

export const JOB_GROUP = {
    SYSTEM: 1
}